import { ReactComponent as JavaScript } from "../../../../../../assets/images/imgly/javascript.svg";
import { ReactComponent as Angular } from "../../../../../../assets/images/imgly/angular.svg";
import { ReactComponent as ReactIcon } from "../../../../../../assets/images/imgly/react.svg";
import { ReactComponent as Vue } from "../../../../../../assets/images/imgly/vue.svg";
import { ReactComponent as Svelte } from "../../../../../../assets/images/imgly/svelte.svg";
import { ReactComponent as NextJs } from "../../../../../../assets/images/imgly/nextjs.svg";
import { ReactComponent as Electron } from "../../../../../../assets/images/imgly/electron.svg";
import * as React from 'react';
export default {
  JavaScript,
  Angular,
  ReactIcon,
  Vue,
  Svelte,
  NextJs,
  Electron,
  React
};